import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Button } from '../../../../components/Buttons';
import { CellButton, CellButtons } from '../CellButton';
import { PerformActionButton } from '../PerformActionButton';
import { View } from '../../../../components/Icon';
import { Loader } from '../../../../components/Loader';
import { Modal, ModalControls } from '../../../../components/Modal';
import { VehicleHeader } from '../../../Vehicles/components/VehicleHeader';
import { Cell } from '../Cell';
import { BaseCellComp } from '../BaseCellComp';
import { selectWorks } from '../../../Api/selectors';
import { performAction } from '../../actions';
import { REQUEST_KANBAN_BOARD_PERFORM_ACTION } from '../../constants';
import { KanbanExtraCostsWrapper } from '../../components/KanbanExtraCostsWrapper';
import ModalComponent from '../../../../containers/App/Components/Modal/Modal';
import ButtonComponent from '../../../../containers/App/Components/Button/Button';
import cn from 'classnames';
import styles from './HOOI.module.css';

const Container = styled.div``;

const STATE = {
  approve: false,
  regplate_code: '',
};

/* eslint-disable react/prefer-stateless-function */
class HOOI_inkomend_transport_aanmakenComp extends BaseCellComp {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  get vehicle() {
    return this.props.cell.vehicle;
  }

  reset() {
    this.setState({ ...STATE });
  }

  confirm() {
    //apprive BVI ...
    this.props.confirm(this.vehicle.id, this.state.regplate_code);
  }

  renderApprove() {
    if (!this.state.approve) return null;

    return (
      <ModalComponent onClose={this.reset.bind(this)} title={this.props.action.label}>
        <VehicleHeader vehicle={this.vehicle} />

        <KanbanExtraCostsWrapper vehicleId={this.vehicle?.id} />
        <div className="d-flex gap-2 mt-2">
          <PerformActionButton className={styles.confirmButton} action={this.props.action} target={this.vehicle} onChange={this.reset.bind(this)} />
          <ButtonComponent style={'ButtonSoftDelete'} onClick={this.reset.bind(this)}>{this.lbl('cancel')}</ButtonComponent>
        </div>
      </ModalComponent>
    );
  }

  render() {
    const vehicle = this.vehicle;
    return (
      <Cell className={styles.cell}>
        <Container>
          <VehicleHeader vehicle={vehicle} />

          <CellButtons>
            {this.props.cell.busy ? (
              <Loader small />
            ) : (
              <div className={styles.cellButtonContainer}>
                <CellButton
                  onClick={this.setStateFn({ approve: !this.state.approve, regplate_code: vehicle?.regplate_code || '' })}
                >
                  <View />
                </CellButton>
              </div>
            )}
          </CellButtons>
        </Container>
        {this.renderApprove()}
      </Cell>
    );
  }
}

HOOI_inkomend_transport_aanmakenComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([`${REQUEST_KANBAN_BOARD_PERFORM_ACTION + ownProps.actionId}_${ownProps.cell.vehicle?.id}`]),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    confirm(vehicle_id, regplate_code) {
      dispatch(performAction(ownProps.action.id, vehicle_id, { regplate_code }));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const HOOI_inkomend_transport_aanmaken = compose(withConnect, withRouter)(HOOI_inkomend_transport_aanmakenComp);
